// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__RO6NL","upload":"Small_upload__1BQq3","imageWrap":"Small_imageWrap__3pLVD","removeBtn":"Small_removeBtn__KKZvd"};